module.exports = __webpack_public_path__ + "static/accolades-074e51ef65927a0eaf7c68d8e36013b6.png";